import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { DecimalPipe } from '@angular/common'
import {provideDaterangepickerLocale} from 'ngx-daterangepicker-bootstrap';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { authInterceptor } from '@core/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
      DecimalPipe,
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes),
      provideHttpClient(withInterceptors([authInterceptor])),
      provideAnimations(),
      provideOAuthClient(),
      provideDaterangepickerLocale({
          separator: ' - ',
          cancelLabel: 'Cancel',
      })
  ],
};
